import './index.scss';

const Contact = () => (
  <section className="contact-section" id="contact">
    <div className="contact-box reveal">
      <div className="contact-left">
        <h2>Let's work<br /><span>together.</span></h2>
        <p>
          Open to 2027 new-grad software engineering roles.<br /> I'm genuinely excited to work on hard problems.
        </p>
      </div>

      <div className="contact-links">
        <a
          href="https://www.linkedin.com/in/jahan-shah-/"
          target="_blank"
          rel="noreferrer"
          className="clink"
        >
          <div>
            <div className="clink-label">Social</div>
            <div className="clink-name">LinkedIn</div>
          </div>
          <span className="clink-arrow">↗</span>
        </a>

        <a
          href="https://github.com/shahjahan0011"
          target="_blank"
          rel="noreferrer"
          className="clink"
        >
          <div>
            <div className="clink-label">Code</div>
            <div className="clink-name">GitHub</div>
          </div>
          <span className="clink-arrow">↗</span>
        </a>

        <a
          href="mailto:jshah.eng@gmail.com"
          className="clink"
        >
          <div>
            <div className="clink-label">Email</div>
            <div className="clink-name">jshah.eng@gmail.com</div>
          </div>
          <span className="clink-arrow">↗</span>
        </a>

        {/* <a href="tel:7785944433" className="clink">
          <div>
            <div className="clink-label">Phone</div>
            <div className="clink-name">778 594 4433</div>
          </div>
          <span className="clink-arrow">↗</span>
        </a> */}

        <a href="https://drive.google.com/file/d/1PvA4tU7OHMRA2FvJRFNqlhSTZa-eQ9OG/view?usp=sharing" className="clink" target="_blank" rel="noreferrer">
          <div>
            <div className="clink-label">Download</div>
            <div className="clink-name">Resume.pdf</div>
          </div>
          <span className="clink-arrow">↗</span>
        </a>
      </div>
    </div>
  </section>
);

export default Contact;
